/**
 * Generated runtime TestId mirror for frontend/src/pages/MyAccess.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const MyAccessTabId = {
  AccessProfiles: "access-profiles",
  Assignments: "assignments",
  EffectiveAccess: "effective-access",
  FunctionGroupAssignments: "function-group-assignments",
  FunctionGroupTimeline: "function-group-timeline",
  FunctionGroups: "function-groups",
  Timeline: "timeline",
} as const;
export type MyAccessTabId = typeof MyAccessTabId[keyof typeof MyAccessTabId];

export const MyAccessTestIds = {
  colAccessProfiles: "col-access-profiles",
  colEaEnforcementObject: "col-ea-enforcement-object",
  colEaOperation: "col-ea-operation",
  colEaResource: "col-ea-resource",
  colEaSourcesCount: "col-ea-sources-count",
  colEaSystem: "col-ea-system",
  colEaValidFrom: "col-ea-valid-from",
  colEaValidTo: "col-ea-valid-to",
  colExpand: "col-expand",
  colExpiresAt: "col-expires-at",
  colFgExpiresAt: "col-fg-expires-at",
  colFgName: "col-fg-name",
  colFgSources: "col-fg-sources",
  colFgStatus: "col-fg-status",
  colSources: "col-sources",
  colStatus: "col-status",
  myAccessOuterTabs: "my-access-outer-tabs",
  myAccessRow: "my-access-row",
  myEffectiveAccessRow: "my-effective-access-row",
  myEffectiveAccessScopeHint: "my-effective-access-scope-hint",
  myFgAssignmentRow: "my-fg-assignment-row",
  myFgEmpty: "my-fg-empty",
  tab: (subtype: MyAccessTabId) => `tab-${subtype}` as const,
  tabPrefix: () => "tab-" as TestIdPrefix,
  eventType: (event_eventType: string) => `event-type-${event_eventType}`,
  eventTypePrefix: () => "event-type-" as TestIdPrefix,
  fgHistory: (fgAssignment_id: string) => `fg-history-${fgAssignment_id}`,
  fgHistoryPrefix: () => "fg-history-" as TestIdPrefix,
  fgName: (fgAssignment_id: string) => `fg-name-${fgAssignment_id}`,
  fgNamePrefix: () => "fg-name-" as TestIdPrefix,
  linkAccessProfile: (assignment_id: string) => `link-access-profile-${assignment_id}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix,
  linkEaEnforcementObject: (grant_accessId: string) => `link-ea-enforcement-object-${grant_accessId}`,
  linkEaEnforcementObjectPrefix: () => "link-ea-enforcement-object-" as TestIdPrefix,
  linkEaResource: (grant_accessId: string) => `link-ea-resource-${grant_accessId}`,
  linkEaResourcePrefix: () => "link-ea-resource-" as TestIdPrefix,
  linkEaSystem: (grant_accessId: string) => `link-ea-system-${grant_accessId}`,
  linkEaSystemPrefix: () => "link-ea-system-" as TestIdPrefix,
  linkFgRule: (source_ruleId: string) => `link-fg-rule-${source_ruleId}`,
  linkFgRulePrefix: () => "link-fg-rule-" as TestIdPrefix,
  linkFunctionGroup: (fgAssignment_id: string) => `link-function-group-${fgAssignment_id}`,
  linkFunctionGroupPrefix: () => "link-function-group-" as TestIdPrefix,
  linkRule: (source_ruleId: string) => `link-rule-${source_ruleId}`,
  linkRulePrefix: () => "link-rule-" as TestIdPrefix,
  myAccessStatus: (assignment_status: string) => `my-access-status-${assignment_status}`,
  myAccessStatusPrefix: () => "my-access-status-" as TestIdPrefix,
  myFgStatus: (fgAssignment_status: string) => `my-fg-status-${fgAssignment_status}`,
  myFgStatusPrefix: () => "my-fg-status-" as TestIdPrefix
} as const;
